import React, { FC } from "react";
import { InputAdornment, SxProps, TextField } from "@mui/material";
import SearchIcon from "../../assets/SearchIcon.svg";
import { searchFieldStyle } from "../../components/customerManagement/DisplayCustomers.styles";

type SearchBarProps = {
  searchTerm: string;
  handleSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const SearchBar: FC<SearchBarProps> = ({ searchTerm, handleSearch }) => {
  const mobileSearchFieldStyle: SxProps = {
    ...searchFieldStyle,
    width: { xs: "175px", sm: "200px" },
  };
  return (
    <TextField
      variant="outlined"
      placeholder="Search"
      value={searchTerm}
      size="small"
      onChange={handleSearch}
      sx={mobileSearchFieldStyle}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <img
              src={SearchIcon}
              width="24.77px"
              height="24px"
              style={{
                top: "7px",
                left: "8.26px",
                gap: "0px",
                opacity: "1",
              }}
              alt="Search"
            />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default SearchBar;
